import { useEffect } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { captureException } from '@sentry/nextjs';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import {
  useUpdateCoachDetailsMutation,
  useUpdateCoachPrepareMutation,
} from 'types/generated/client';
import { useViewer } from 'hooks/useViewer';
import CloseIcon from 'svg/CloseIcon';
import { isCoachProfile } from 'screens/PlayerHome/utils';
import Button, { ButtonText } from 'components/Button';
import InputField from 'components/coaches-builder/InputField';
import { InputType } from 'components/coaches-builder/InputField/InputField';
import ProfileItem from 'components/coaches-builder/ProfileItem';
import Modal from 'components/modals/Modal';
import { prepareSchema } from './schemas';
import { FormModalModeEnum, FormModalProps } from '../types';

interface PrepareFormModalProps extends FormModalProps {}

type PrepareSchemaType = z.infer<typeof prepareSchema>;

const PrepareFormModal: React.FC<PrepareFormModalProps> = ({
  isOpen,
  handleClose,
  coachData,
  mode,
}) => {
  const {
    register,
    formState: { errors },
    setValue,
    reset,
    handleSubmit,
  } = useForm<z.infer<typeof prepareSchema>>({
    resolver: zodResolver(prepareSchema),
  });

  const [updateCoachPrepare, { loading: updateCoachPrepareLoading }] =
    useUpdateCoachPrepareMutation();

  const viewer = useViewer();

  const onSubmit = async (data: PrepareSchemaType) => {
    try {
      await updateCoachPrepare({
        variables: {
          userId: viewer.userId,
          coachLessonHowToPrepare: data.coachLessonHowToPrepare,
        },
      });
      handleClose(true);
    } catch (err) {
      captureException(err);
    }
  };

  useEffect(() => {
    // if (mode === FormModalModeEnum.Add) {
    //   reset();
    //   return;
    // }
    if (!coachData) {
      return;
    }

    setValue('coachLessonHowToPrepare', coachData?.coachLessonHowToPrepare!);
  }, [coachData, reset, setValue, mode]);

  return (
    <Modal isOpen={isOpen} handleClose={handleClose} classNameMaxWidth="max-w-[80vw]">
      <div className="flex items-center justify-between border-b px-8 py-4">
        <h2 className="typography-product-heading-desktop">How to prepare</h2>
        <ButtonText onClick={() => handleClose()}>
          <CloseIcon className="h-4 w-4" />
        </ButtonText>
      </div>
      <div className="flex flex-col px-4 md:px-10">
        <ProfileItem
          label="Description"
          customClass="xs:mb-20 lg:mb-0"
          description="Introduce yourself and explain how you get into coaching."
          hasBottomBorder={false}
          component={
            <InputField
              fieldLabel=""
              errors={errors}
              placeholder="Tell more about lessons preparation"
              name="coachLessonHowToPrepare"
              register={register}
              inputType={InputType.Textarea}
            />
          }
        />
      </div>
      <div className=" flex justify-end border-t px-8 py-4">
        <Button
          variant="primary"
          disabled={updateCoachPrepareLoading}
          onClick={handleSubmit(onSubmit)}
          className="w-fit"
          size="lg"
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};

export default PrepareFormModal;
